import script from "./WeChatMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeChatMenu.vue?vue&type=script&lang=ts&setup=true"

import "./WeChatMenu.vue?vue&type=style&index=0&id=0a60ea77&lang=css"

const __exports__ = script;

export default __exports__